export default __webpack_public_path__ + "static/media/cloud-upload.737c1e32.png";